import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(headerStyles, {
    titleGridItem: {
        width: [9, 9, 5, 5, 5],
        css: css`
            align-items: center;
            /*font-size: 22px;
            text-transform: uppercase;
            font-weight: 600;*/
        `,
    },
    buttonGridItem: {
        css: css`
            justify-content: flex-end;
        `,
        width: [3, 3, 7, 7, 7],
    },
    title: {
        variant: "h2",
        as: "p",
        css: css`
            @media print {
                variant: "h2";
            }
            text-transform: uppercase;
            font-weight: 600;
        `,
    },
});
